// "LAB-Assistant" is a staff role (staff.type / staffType). Matching ignores
// case, spaces and dashes so "Lab Assistant" and "lab_assistant" count too.
export function isLabAssistantStaff(staff) {
  const raw = staff?.staffType || staff?.type || staff?.role || '';
  return String(raw).toLowerCase().replace(/[^a-z]/g, '') === 'labassistant';
}
